<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>NaloxoFind</span>
        <span class="font-weight-light"> Contributor Page</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="showLogin" flat to="./login">
        <span class="mr-2">Login</span>
      </v-btn>
      <v-btn v-else flat to="./logout">
        <span class="mr-2">Logout</span>
      </v-btn>
      <v-btn v-if="isAdmin" flat to="./admin">
        <span class="mr-2">Admin</span>
      </v-btn>
    </v-toolbar>

    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>


<script>
import {mapState} from 'vuex'

export default {
  name: 'App',
  components: {

  },
  data () {
    return {
        currentUser: null
      //
    }
  },
  computed: {
    ...mapState({
      uid: state => state.locations.uid,
      isAdmin: state => state.admin.isAdmin,
    }),
    showLogin: function () {
        return !this.uid || this.uid == null
    }
  },
  async mounted () {

      // this.currentUser = firebase.auth().currentUser
      // if (this.currentUser && this.currentUser !== null) {
      //     this.showLogin = false;
      // } else {
      //     this.showLogin = true;
      // }
      //
      // firebase.auth().onAuthStateChanged((user) => {
      //   console.log("AUTH CHANGE IN APP")
      //   if (user) {
      //     console.log("User already logged in")
      //     // User is already signed in.
      //     this.showLogin = false;
      //   } else {
      //     this.showLogin = true;
      //   }
      // });

  }

}
</script>
